import { IAttribute, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { CustomizerFilter, FilterOption } from '../models';

export const setOptionsChecked = (group: IProductWithAttributes, filters: CustomizerFilter[]) => {
  filters.forEach((f: CustomizerFilter) => {
    if (!f.available) {
      return;
    }

    f.options
      .filter((o: FilterOption) => o.visible)
      .forEach((o: FilterOption) => {
        o.checked = group.attributes.some((a: IAttribute) => a.key === f.name && a.valueKey === o.value);
      });
  });
};
